export default "__VITE_ASSET__eeb8cf17__"